var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.$isMobile())?_c('div',{key:"mobile",style:(_vm.style)},[_c('v-img',{staticStyle:{"margin":"auto","width":"50%"},attrs:{"src":require('@/assets/C_RGB APP.png'),"position":"center"}})],1):_c('Home')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }